import React from 'react';
import playStoreImg from "../../../assets/img/storeIcons.jpg";

const Pointbalance = () => {
  const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.sintexr.app&hl=en_IN';
  const appStoreUrl = 'https://apps.apple.com/in/app/sintexhamesha-retailer/id1444431364';

  // Detect device
  const userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent || navigator.vendor || window.opera;
  
  let storeLink = playStoreUrl; // default

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    storeLink = appStoreUrl;
  } else if (/android/i.test(userAgent)) {
    storeLink = playStoreUrl;
  }

  return (
    <>
      <div style={{ height: "100vh", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", textAlign: "center" }}>
        <a href={storeLink} target="_blank" rel="noopener noreferrer">
          <img src={playStoreImg} style={{ height: "80px", cursor: "pointer" }} alt="Download App" />
          <p>Tap here to download the app</p>
          <p>and get started!</p>
        </a>
      </div>
    </>
  );
};

export default Pointbalance;
